module.exports = __webpack_public_path__ + "img/contact.1c7367bb.webp";